module.exports = __webpack_public_path__ + "img/EstatePlanning.2cd9624d.jpg";